import { Box, Icon, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { ActionText } from 'components/atoms/Text'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
const ActivityListContainer = ({
  children,
  title,
  icon,
  itemCount,
  viewAllAction,
  titleNavigation,
  listTitle,
  backgroundColor = colors.MetalGrey50
}) => {
  const { t } = useTranslation()
  return (
    <Grid size={4} minWidth={420}>
      <Stack padding={0} spacing={8} width='100%'>
        <RowStack spacing={2} width='unset'>
          <Icon>{icon}</Icon>
          <Typography variant='h4'>{title}</Typography>
          {titleNavigation}
        </RowStack>
        <BoxWithBackground
          backgroundColor={itemCount ? backgroundColor : colors.MetalGrey50}
          width='100%'>
          <Stack spacing={4} padding={0}>
            {itemCount > 0 && (
              <RowStack justifyContent='space-between' height={24}>
                <Typography variant='eyebrow'>{listTitle}</Typography>
                <Box>
                  {viewAllAction && (
                    <ActionText
                      onClick={viewAllAction}
                      variant='buttonSmall'
                      sx={{
                        textDecoration: 'underline',
                        textTransform: 'uppercase'
                      }}>
                      {t('common.seeAll')}
                    </ActionText>
                  )}
                </Box>
              </RowStack>
            )}
            {children}
          </Stack>
        </BoxWithBackground>
      </Stack>
    </Grid>
  )
}

export default ActivityListContainer
